'use client';

import React, { useEffect, useRef, useState } from 'react';
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import Image from 'next/image';

type JobImageSlideProps = {
  imageUrls: string[];
  jobTitle?: string;
};

const JobImageSlide: React.FC<JobImageSlideProps> = ({
  imageUrls,
  jobTitle,
}) => {
  const mainSplideRef = useRef<Splide | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (imageUrls.length > 1) {
      const main = new Splide('#main-carousel', {
        type: 'loop',
        perPage: 1,
        pagination: false,
        arrows: true,
      });

      main.on('moved', (newIndex) => {
        setActiveIndex(newIndex);
      });

      main.mount();
      mainSplideRef.current = main;
    }
  }, [imageUrls]);

  if (imageUrls.length === 0) return null;

  return (
    <>
      {imageUrls.length > 1 ? (
        <>
          <section
            id="main-carousel"
            className="splide"
            aria-label="お気に入りの写真"
          >
            <div className="splide__track">
              <ul className="splide__list">
                {imageUrls.map((url, index) => (
                  <li className="splide__slide" key={index}>
                    <Image
                      src={url}
                      alt={jobTitle || '求人詳細の画像'}
                      width={300}
                      height={200}
                      loading="lazy"
                      className="p-job-detail__image"
                      unoptimized
                    />
                  </li>
                ))}
              </ul>
            </div>
          </section>

          <ul id="thumbnails" className="splide__thumbnails">
            {imageUrls.map((url, index) => (
              <li
                key={index}
                className={`splide__thumbnail ${
                  index === activeIndex ? 'is-active' : ''
                }`}
                onClick={() => {
                  mainSplideRef.current?.go(index);
                  setActiveIndex(index); // サムネイルクリック時も同期
                }}
                style={{ cursor: 'pointer' }}
              >
                <Image
                  src={url}
                  alt={jobTitle || '求人詳細の画像'}
                  width={70}
                  height={50}
                  loading="lazy"
                  className="splide__thumbnail-img"
                  unoptimized
                />
              </li>
            ))}
          </ul>
        </>
      ) : (
        <Image
          src={imageUrls[0]}
          alt={jobTitle || '求人詳細の画像'}
          width={300}
          height={200}
          loading="lazy"
          className="p-job-detail__image"
          unoptimized
        />
      )}
    </>
  );
};

export default JobImageSlide;
